import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 09E1A31D-448C-42D3-A220-2ACBD0D8B211
 * name chevron-triple-left
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/chevron-triple-left.svg
 * tags
 */
export const ChevronTripleLeftIcon = createSvgIcon(<><path d="M9.42,7.41L4.83,12L9.42,16.59L8,18L2,12L8,6L9.42,7.41M15.42,7.41L10.83,12L15.42,16.59L14,18L8,12L14,6L15.42,7.41M21.42,7.41L16.83,12L21.42,16.59L20,18L14,12L20,6L21.42,7.41Z" /></>, 'ChevronTripleLeftIcon');
export default ChevronTripleLeftIcon